import React, { type ComponentProps } from 'react';

import { BodyText } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuTopDownCategoriesItemDescription = (props: ComponentProps<typeof BodyText>) => {
  const { children, ...restProps } = props;

  return (
    <BodyText sizeMatch={['14']} {...restProps}>
      {children}
    </BodyText>
  );
};
